import { IonButton, IonIcon, IonItem } from '@ionic/react';
import styled from 'styled-components';
import { AllieButton } from '../Buttons/Button';
import { AllieItem } from '../Item/Item';
import { StyledSearchbar } from '../Searchbar/Searchbar.styles';

interface StyledItemProps extends React.ComponentProps<typeof IonItem> {
  selected?: boolean;
}

export const SearchableStyledButton: typeof AllieButton = styled(AllieButton)`
  color: var(--allie-color-neutral-50);
  --border-color: var(--allie-color-light-40);
  --border-width: 1px;
  &::part(native) {
    height: 100%;
  }

  .btn-inner-container {
    width: 100%;
    display: flex;
  }
`;

export const StyledItem: any = styled(AllieItem)<StyledItemProps>`
  color: var(--allie-color-neutral-60);
  --background: ${(props) => (props.selected ? 'var(--allie-color-neutral-20)' : '')};
  background: ${(props) => (props.selected ? 'var(--allie-color-neutral-20)' : '')};
  --inner-padding-end: 0;
  --inner-padding-start: 0;
  &::part(native) {
    padding: 0 25px;
  }
`;

export const StyledSearchableItemDropdown = styled(AllieItem)`
  height: 41px;
  border: 1px solid var(--allie-color-neutral-30);
  border-radius: 8px;
  color: var(--allie-color-neutral-50);
  &::part(native) {
    min-height: unset;
  }
`;

export const IconContainer: typeof IonIcon = styled(IonIcon)`
  font-size: 14px !important;
  fill: var(--allie-color-neutral-40);
`;

export const StyledTextContainer = styled.div<{ weight?: number }>`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  font-weight: ${(props) => props.weight || 500};
`;

export const StyledDropdownSearchBar = styled(StyledSearchbar)`
  input {
    padding-inline-end: 10px;
  }
`;

export const ParentContainer = styled.div<{ maxHeight: number }>`
  flex: 1;
  min-height: 0;
  overflow: auto;
  position: relative;
  will-change: transform;
  contain: content;
`;

export const BadgeMultipleSelect = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 50%;
  background: var(--allie-color-primary-main);
  color: var(--allie-color-white);
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
  flex-shrink: 0;
  margin-left: var(--allie-spacing-xs);
`;
